export const switchLoginMode = 'switchLoginMode'

export const updateUsername = 'updateUsername'

export const setUsernameDirty = 'updateUsernameDirty'

export const updatePassword = 'updatePassword'

export const setPasswordDirty = 'updatePasswordDirty'

export const updateConfirmPassword = 'updateConfirmPassword'

export const setConfirmPasswordDirty = 'updateConfirmPasswordDirty'

export const updateSecretCode = 'updateSecretCode'

export const setSecretCodeDirty = 'updateSecretCodeDirty'

export const setSecretCodeSending = 'setSecretCodeSending'

export const tickCodeDelayTimer = 'tickCodeDelayTimer'

export const codeSendFailed = 'codeSendFailed'

export const resetSecretCodeSendingDelay = 'resetSecretCodeSendingDelay'

export const setAuthInProgress = 'setAuthInProgress'

export const setAuthFailed = 'setAuthFailed'

export const setExistingPasswordUsed = 'setExistingPasswordUsed'

export const setPasswordPolicy = 'setPasswordPolicy'

export const setSsoInformation = 'setSsoInformation'

export const setPasswordPolicyPending = 'setPasswordPolicyPending'

export const setInstanceAvailable = 'setInstanceAvailable'

export const setInstanceProperties = 'setInstanceProperties'

export const enableRequestingNewCode = 'enableRequestingNewCode'

export const updateAuditMessage = 'updateAuditMessage'

export const setAuditMessageDirty = 'setAuditMessageDirty'

export const setAuditSubmitFailed = 'setAuditSubmitFailed'

export const onUpdateView = 'onUpdateView'

